<div class="popWrap01">
  <div class="pop_header">
    <h1> {{ 'COMMON.BUTTON.LOG_OUT' | translate }} </h1>
  </div>
  <div class="pop_cont">
    <div class="cont">
      <p> {{ 'COMMON.MESSAGE.DO_YOU_WANT_TO_LOG_OUT' | translate }} </p>
    </div>
    <div class="c_btn">
      <div class="wrap_btn btn_right">
        <button type="button" class="btn02" (click)="close()"> 
          <span> {{ 'COMMON.BUTTON.CANCEL' | translate }} </span>
        </button>
        <button type="button" class="btn01" (click)="logout()">
          <span> {{ 'COMMON.BUTTON.LOG_OUT' | translate }} </span>
        </button>
      </div>
    </div>
  </div>
</div>